import React, {FC} from "react";
import {AppBar, Toolbar} from "@material-ui/core";
import {HideOnScroll} from "../../sharedComponents/HideOnScroll";
import {OrderEngineMobileHeader} from "./OrderEngineMobileHeader";
import {OrderEngineDesktopHeader} from "./OrderEngineDesktopHeader";

export const OrderEngineHeader: FC<{ showImage: boolean; isDesktop: boolean }> = ({showImage, isDesktop}) => {
    return (
        <React.Fragment>
            <HideOnScroll direction={"down"}>
                <AppBar color={"inherit"} position="sticky">
                    <Toolbar>
                        {isDesktop ? <OrderEngineDesktopHeader/> : <OrderEngineMobileHeader/>}
                    </Toolbar>
                </AppBar>
            </HideOnScroll>
        </React.Fragment>
    );
}
